export const FLAG_GETTING_CARGO_MINIMAL_PRICES =
  'FLAG_GETTING_CARGO_MINIMAL_PRICES';
export const GET_CARGO_MINIMAL_PRICES = 'GET_CARGO_MINIMAL_PRICES';
export const CLEAR_CARGO_MINIMAL_PRICES = 'CLEAR_CARGO_MINIMAL_PRICES';
export const FLAG_CARGO_MINIMAL_PRICE_ACTIVITY =
  'FLAG_CARGO_MINIMAL_PRICE_ACTIVITY';
export const GET_CARGO_MINIMAL_PRICE = 'GET_CARGO_MINIMAL_PRICE';
export const CLEAR_CARGO_MINIMAL_PRICE = 'CLEAR_CARGO_MINIMAL_PRICE';
